export default __webpack_public_path__ + "static/media/Fill.dee005bc.svg";